var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-env browser */

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.events = {};
  }

  _createClass(EventEmitter, [{
    key: 'on',
    value: function on(event, callback) {
      if (_typeof(this.events[event]) !== 'object') {
        this.events[event] = [];
      }
      this.events[event].push(callback);
    }
  }, {
    key: 'off',
    value: function off(event, callback) {
      this.removeListener(event, callback);
    }
  }, {
    key: 'removeListener',
    value: function removeListener(event, callback) {
      if (_typeof(this.events[event]) === 'object') {
        var index = this.events[event].indexOf(callback);
        if (index !== -1) {
          this.events[event].splice(index, 1);
        }
      }
    }
  }, {
    key: 'removeAllListeners',
    value: function removeAllListeners() {
      this.events = {};
    }
  }, {
    key: 'emit',
    value: function emit(event, value) {
      if (_typeof(this.events[event]) === 'object') {
        this.events[event].filter(function (cb) {
          return cb != null;
        }).forEach(function (cb) {
          return cb(value);
        });
      }
    }
  }]);

  return EventEmitter;
}();

export default EventEmitter;